function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import React from 'react';
import classNames from 'classnames';
import { BOS, HALIFAX, LLOYDS, MBNA } from "../../constants";
import { useBrand } from "../BrandProvider";
import { useInverse } from "../BackgroundProvider";
import Paragraph from "../Paragraph";
import BosSpinner from "../../themes/assets/img/spinner.bos.gif";
import HalifaxSpinner from "../../themes/assets/img/spinner.halifax.gif";
import LloydsSpinner from "../../themes/assets/img/spinner.lloyds.gif";
import MbnaSpinner from "../../themes/assets/img/spinner.mbna.gif";
import StyledSpinner, { StyledSpinnerSvg } from "./styled";
import { useTheme } from 'styled-components';
var Spinner = function Spinner(_ref) {
  var className = _ref.className,
    message = _ref.message,
    inverseProp = _ref.inverse,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'default' : _ref$size,
    title = _ref.title;
  var theme = useTheme() || {};
  var inverse = inverseProp !== undefined ? inverseProp : useInverse(theme);
  var classes = classNames("csl-spinner__icon--".concat(size), className);
  var _ref2 = useBrand() || {},
    _ref2$brand = _ref2.brand,
    brand = _ref2$brand === void 0 ? LLOYDS : _ref2$brand;
  var isIE = (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && document.documentMode;
  var spinner;
  switch (brand) {
    case BOS:
      spinner = BosSpinner;
      break;
    case HALIFAX:
      spinner = HalifaxSpinner;
      break;
    case LLOYDS:
      spinner = LloydsSpinner;
      break;
    case MBNA:
      spinner = MbnaSpinner;
      break;
    default:
      spinner = BosSpinner;
  }
  return /*#__PURE__*/React.createElement(StyledSpinner, {
    className: "csl-spinner"
  }, !isIE && /*#__PURE__*/React.createElement(StyledSpinnerSvg, {
    $inverse: inverse,
    $size: size,
    className: "csl-spinner__icon ".concat(classes),
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "47",
    y: "9",
    rx: "13.16",
    ry: "2.52",
    width: "6",
    height: "22"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.9166666666666666s",
    repeatCount: "indefinite"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(30 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "47",
    y: "9",
    rx: "13.16",
    ry: "2.52",
    width: "6",
    height: "22"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.8333333333333334s",
    repeatCount: "indefinite"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(60 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "47",
    y: "9",
    rx: "13.16",
    ry: "2.52",
    width: "6",
    height: "22"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.75s",
    repeatCount: "indefinite"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(90 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "47",
    y: "9",
    rx: "13.16",
    ry: "2.52",
    width: "6",
    height: "22"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.6666666666666666s",
    repeatCount: "indefinite"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(120 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "47",
    y: "9",
    rx: "13.16",
    ry: "2.52",
    width: "6",
    height: "22"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.5833333333333334s",
    repeatCount: "indefinite"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(150 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "47",
    y: "9",
    rx: "13.16",
    ry: "2.52",
    width: "6",
    height: "22"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.5s",
    repeatCount: "indefinite"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(180 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "47",
    y: "9",
    rx: "13.16",
    ry: "2.52",
    width: "6",
    height: "22"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.4166666666666667s",
    repeatCount: "indefinite"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(210 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "47",
    y: "9",
    rx: "13.16",
    ry: "2.52",
    width: "6",
    height: "22"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.3333333333333333s",
    repeatCount: "indefinite"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(240 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "47",
    y: "9",
    rx: "13.16",
    ry: "2.52",
    width: "6",
    height: "22"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.25s",
    repeatCount: "indefinite"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(270 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "47",
    y: "9",
    rx: "13.16",
    ry: "2.52",
    width: "6",
    height: "22"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.16666666666666666s",
    repeatCount: "indefinite"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(300 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "47",
    y: "9",
    rx: "13.16",
    ry: "2.52",
    width: "6",
    height: "22"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.08333333333333333s",
    repeatCount: "indefinite"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(330 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "47",
    y: "9",
    rx: "13.16",
    ry: "2.52",
    width: "6",
    height: "22"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "0s",
    repeatCount: "indefinite"
  })))), isIE && /*#__PURE__*/React.createElement("img", {
    src: spinner,
    alt: "Spinner",
    height: size === 'small' ? '24' : '56',
    width: size === 'small' ? '24' : '56'
  }), title && /*#__PURE__*/React.createElement(Paragraph, {
    marginBottom: "none",
    marginTop: "02",
    inverse: inverse,
    size: "s2",
    weight: "bold",
    className: "csl-spinner__title"
  }, title), message && /*#__PURE__*/React.createElement(Paragraph, {
    marginBottom: "none",
    marginTop: "02",
    inverse: inverse,
    size: "s1",
    className: "csl-spinner__message"
  }, message));
};
Spinner.displayName = 'Spinner';
export default Spinner;